import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import * as React from 'react';
import { AttachmentPillData, AttachmentPillViewStatus } from '../store/schema/AttachmentPillData';
import { AttachmentIconView } from 'owa-attachment-view';
import { IconSize } from 'owa-attachment-common-view';
import { AttachmentModel } from 'owa-attachment-model-store';
import { observer } from 'mobx-react-lite';
import { onPillAttached, onAttachFailed } from '../actions/internalActions';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import ItemId from 'owa-service/lib/contract/ItemId';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import createAttachmentFromRecentAttachmentsPills from '../utils/createAttachmentFromRecentAttachmentsPills';
import { MailboxInfo } from 'owa-client-ids';
import { DP_RECENT_ATTACHMENT_PILLS_CLICK_PILL, ON_PILL_CLICK } from '../constants';
import { logUsage } from 'owa-analytics';
import { DefaultButton } from '@fluentui/react/lib/Button';

const styles = require('./RecentAttachmentPill.scss');

export interface RecentAttachmentPillProps {
    attachmentPillsData: AttachmentPillData;
    composeId: string;
    itemId: ItemId;
    attachmentWell: AttachmentWellViewState;
    infoBar: InfoBarHostViewState;
    mailboxInfo: MailboxInfo;
    logGeneralInteraction: (source: string) => void;
}

export default observer(function RecentAttachmentPill(props: RecentAttachmentPillProps) {
    const {
        attachmentPillsData,
        composeId,
        attachmentWell,
        itemId,
        infoBar,
        mailboxInfo,
        logGeneralInteraction,
    } = props;
    const attachment: AttachmentModel = getAttachment(attachmentPillsData.attachmentId!);

    const onAttachmentCreation = (attachmentCreated: boolean) => {
        if (!attachmentCreated) {
            onAttachFailed(composeId, attachmentPillsData.attachmentId!);
        }
    };

    const onAttachmentPillClicked = () => {
        logUsage(DP_RECENT_ATTACHMENT_PILLS_CLICK_PILL);
        logGeneralInteraction(ON_PILL_CLICK);
        onPillAttached(composeId, attachmentPillsData.attachmentId!);
        createAttachmentFromRecentAttachmentsPills(
            [attachmentPillsData],
            onAttachmentCreation,
            itemId,
            attachmentWell,
            infoBar,
            mailboxInfo
        );
    };

    if (attachmentPillsData.attachmentPillViewStatus === AttachmentPillViewStatus.Show) {
        return (
            <DefaultButton
                title={attachment.model.Name}
                className={styles.attachmentPillButton}
                onClick={onAttachmentPillClicked}>
                <AttachmentIconView
                    attachmentId={attachmentPillsData.attachmentId!}
                    className={styles.iconCompactMode}
                    iconSize={IconSize.extraSmall}
                />
                <div className={styles.attachmentButton}>{attachment.model.Name}</div>
            </DefaultButton>
        );
    }
    return null;
});
